import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import moment from 'moment-timezone'

import SearchField from 'components/SearchField'
import Button from 'components/buttons/Button'

import SectionWithHeader from 'layout/SectionWithHeader'
import TimesheetsList from 'lists/TimesheetsList'

import TimesheetsAPI from 'api/TimesheetsAPI'
import FortnightPickerField from 'components/FortnightPickerField'

import {dateToFortnight} from 'utils/time'

import styles from './index.css'

@withRouter
export default class Timesheets extends React.Component {
  
  static propTypes = {
  }

  constructor(props) {
    super(props)
    this.fetchTimesheets = this.fetchTimesheets.bind(this)

    const { search, fortnight } = JSON.parse(window.sessionStorage["timesheets_list"] || '{}')
    this.state = {
      fortnight: fortnight ? new Date(fortnight) : dateToFortnight(new Date()).from,
      search: search || '',
      timesheets: []
    }
  }


  async fetchTimesheets() {
    this.setState({ loading: true })
    const { search, fortnight } = this.state 
    const {response} = await TimesheetsAPI.list({ 
      search, 
      start_date: moment(fortnight).format('YYYY-MM-DD')
    })
    this.setState({ timesheets: response })
    this.setState({ loading: false })
  }

  componentDidMount() {
    this.fetchTimesheets()
  }

  componentDidUpdate(prevProps, prevState) {
    let needsFetching = false
    if (
      (!prevState.fortnight && this.state.fortnight) ||
      (prevState.fortnight && prevState.fortnight.getTime() !== this.state.fortnight.getTime())
    ) {
      needsFetching = true
    }
    if (prevState.search !== this.state.search) {
      needsFetching = true
    }
    if (needsFetching) {
      window.sessionStorage["timesheets_list"] = JSON.stringify({ 
        search : this.state.search,
        fortnight : this.state.fortnight
      })
      this.fetchTimesheets()
    }
  }

  render() {
    return (
      <div className={styles.Page}>
         <SectionWithHeader
          title={"Time Sheets"}
          headerChildren={
            <div style={{display: 'flex'}}>
              <div style={{paddingRight: '1rem'}}>
                <SearchField 
                  placeholder='Search user' 
                  defaultValue={this.state.search}
                  onChange={search => this.setState({ search })}
                  />
              </div>
              <div style={{paddingRight: '1rem'}}>
                <FortnightPickerField 
                  value={this.state.fortnight}
                  onChange={fortnight => this.setState({ fortnight })}
                  />
              </div>
              {/*<Button
                color='darkgreywhite'
                fullWidth={false}
                style={{marginRight: '1rem'}}
                onClick={() => {}}>
                Apply
              </Button>
              <Button
                color='greyblue'
                fullWidth={false}
                onClick={() => {}}>
                Reset
              </Button>*/}
            </div>
          }>
          <TimesheetsList 
            loading={this.state.loading}
            entities={this.state.timesheets} 
            />
        </SectionWithHeader>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/Timesheets/index.jsx